const Brand = ({ useBlack = true }) => {
  const textColor = useBlack ? "#1a2236" : "#f0f2f5";
  const mutedColor = useBlack ? "#74788d" : "#9299a8";
  return (
    <a href="/" style={{ display: "inline-flex", alignItems: "center", gap: 10, textDecoration: "none", padding: 0 }}>
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
        <defs>
          <linearGradient id="brand-grad" x1="0" y1="0" x2="34" y2="34" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#f7cc53" />
            <stop offset="100%" stopColor="#f1734f" />
          </linearGradient>
        </defs>
        <rect width="34" height="34" rx="9" fill="url(#brand-grad)" />
        <rect x="7" y="9"  width="20" height="3.5" rx="1.75" fill="white" fillOpacity="0.9" />
        <rect x="7" y="15" width="14" height="3.5" rx="1.75" fill="white" fillOpacity="0.65" />
        <rect x="7" y="21" width="17" height="3.5" rx="1.75" fill="white" fillOpacity="0.45" />
        <circle cx="27" cy="8" r="3" fill="white" fillOpacity="0.75" />
      </svg>
      <span style={{ fontFamily: "Montserrat, sans-serif", fontSize: 17, fontWeight: 700, letterSpacing: "-0.3px", lineHeight: 1, color: textColor, userSelect: "none" }}>
        my<span style={{ color: "#f1734f" }}>media</span><span style={{ fontWeight: 400, color: mutedColor }}>planner</span>
      </span>
    </a>
  );
};

export default Brand;
